import { useEffect, useRef } from 'react';
import {
  deliveryOptionsPayWithCashCheckboxClickHandler,
  deliveryOptionsPayWithCashCheckboxHandler,
  getUpdateForCheckoutDetailsAndAnalytics,
  paymentDetailsAnalytics,
  updateCheckoutDetaisLoggedIn,
} from 'common/utilities/PaymentUtils';
import { getTenders } from 'common/utilities/content';
import { getPaymentBaseTemplate } from '../presentation/templates/PaymentViewTemplates';
import { PAYMENT_GATEWAYS, PAYMENT_TENDER_TYPES } from 'common/constants/SharedConstants';
import { resetPaymentStatus } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const Payment = props => {
  const { checkoutDetails, updateCheckoutDetails } = props;
  const { dispatch, tender, isPaymentTypeSelected } = checkoutDetails;
  const checkoutDetailsUseRef = useRef(checkoutDetails);

  useEffect(() => {
    let updateDetails = { paymentPanelTitle: TRANSLATE_MAPPING_KEY?.ADD_PAYMENT_METHOD_HEADER };
    switch (checkoutDetails?.paymentProvider) {
      case PAYMENT_GATEWAYS.GLOBAL_PAYMENTS:
        updateDetails = {
          enablePayOnArrival: true,
          payOnArrivalAllowedTenders: checkoutDetails?.allowedTenders?.filter(
            item => item === PAYMENT_TENDER_TYPES.PAY_BY_CASH,
          ),
          payNowAllowedTenders: checkoutDetails?.allowedTenders?.filter(
            item => item !== PAYMENT_TENDER_TYPES.PAY_BY_CASH,
          ),
          paymentPanelTitle: TRANSLATE_MAPPING_KEY?.PAYMENT_BY,
        };
        break;
      case PAYMENT_GATEWAYS.PAY_GATE:
        updateDetails = { paymentPanelTitle: TRANSLATE_MAPPING_KEY?.PAYMENT_BY };
        break;
      //no default
    }
    updateCheckoutDetails(updateDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch && dispatch?.(getTenders?.());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    checkoutDetailsUseRef.current = checkoutDetails;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaymentTypeSelected, tender?.name, tender?.payload]);

  useEffect(() => {
    getUpdateForCheckoutDetailsAndAnalytics(checkoutDetails, updateCheckoutDetails);
    dispatch && dispatch(resetPaymentStatus());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.paymentEnabled]);

  useEffect(() => {
    // console.log(checkoutDetails?.tender?.name)
    checkoutDetails?.tender?.name && paymentDetailsAnalytics(checkoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.tender?.name]);

  /*********************************************************************
   *
   * console.debug(new Date().getTime(), ' updateCheckoutDetailsWithCartDataTenantReducer *********> ', checkoutDetails);
   *********************************************************************/
  useEffect(() => {
    checkoutDetails?.userParams?.loggedIn && updateCheckoutDetaisLoggedIn(checkoutDetails, updateCheckoutDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    checkoutDetails?.userFullName?.value,
    checkoutDetails?.userEmail?.value,
    checkoutDetails?.userPhone?.value,
  ]);

  useEffect(() => {
    if (checkoutDetails?.enablePayOnArrival && checkoutDetails?.enablePayByCashOption) {
      const checked = deliveryOptionsPayWithCashCheckboxHandler(checkoutDetails, updateCheckoutDetails);
      updateCheckoutDetails({
        isClickAddPayment: checked,
        isClickPayOnArrival: checked,
        isPaymentTypeSelected: checked,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.enablePayOnArrival, checkoutDetails?.userOption]);

  useEffect(() => {
    if (checkoutDetails?.enablePayOnArrival && checkoutDetails?.enablePayByCashOption) {
      deliveryOptionsPayWithCashCheckboxClickHandler(checkoutDetails, updateCheckoutDetails);
      updateCheckoutDetails({
        isClickAddPayment: checkoutDetails?.isClickPayOnArrival,
        isPaymentTypeSelected: checkoutDetails?.isClickPayOnArrival,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isClickPayOnArrival]);

  return getPaymentBaseTemplate({ ...props, checkoutDetailsUseRef });
};

export default Payment;
